export function reviewSlider() {
    let $slider = $(".review-slider");
    let $navSlider = $(".slider-bg");
    let dotContainerClass = ".review-slider-nav";


    $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        speed: 500,
        fade: true,
        autoplay: true,
        autoplaySpeed: 12000,
        adaptiveHeight: false,
        arrows: false,
        dots: true,
        appendDots: $(dotContainerClass),
        asNavFor: $navSlider,
    });

    $navSlider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        speed: 500,
        fade: true,
        arrows: false,
        dots: false,
    });

    if ($slider.find(".review-slide").length >= 5) {
        $(dotContainerClass).addClass("short-lines");
    }
};


// WEBPACK FOOTER //
// ./assets/js/modules/reviewSlider.js